/* eslint-disable */

//tslint:disable

export var EStatus;
(function (EStatus) {
  EStatus["Success"] = "success";
  EStatus["Wrong"] = "wrong";
  EStatus["CheckPassword"] = "checkPassword";
  EStatus["CodeInputLimitReached"] = "codeInputLimitReached";
  EStatus["CodeExpired"] = "codeExpired";
  EStatus["ManyAccounts"] = "manyAccounts";
})(EStatus || (EStatus = {}));